// extracted by mini-css-extract-plugin
export default {"list":"SectionFilters-module__list__uiX1NgX"};